module.exports = __webpack_public_path__ + "img/rain.e1ffdbed.svg";